import React, { useEffect, useState } from 'react'
import PageContainer from 'src/components/container/PageContainer'
import DashboardCard from 'src/components/shared/DashboardCard'
import Category from './Category'
import { Box, Grid } from '@mui/material'
import { useMain } from '../hooks/useMain'
import ShowLoader from 'src/components/CustomComponents/ShowLoader'

const AllCategory = () => {
    const [categories, setCategories] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    const { getAllCategory } = useMain();

    const getCategories = async () => {
        setShowLoader(true);
       
        const res = await getAllCategory();
       
        setCategories(res?.data?.categories);
        setShowLoader(false);
    }

    useEffect(() => {
        getCategories();

        return () => { }
    }, []);

    return (
        <PageContainer title="All Category" description="this contains all categories">
            <DashboardCard title="All Category">
                <Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12}>
                            <Category categories={categories} setCategories={setCategories} />
                        </Grid>
                    </Grid>
                </Box>
                {showLoader && <ShowLoader value={showLoader} />}
            </DashboardCard>
        </PageContainer>
    )
}

export default AllCategory
